// extracted by mini-css-extract-plugin
module.exports = {"miniForm":"ShippingCriteriaForm_miniForm__1yxQP"};